export default __webpack_public_path__ + "static/media/coach_ok.8504f24a.png";